import { cva } from '@betterment/samba-styled-system/css';

export const navItemStyles = cva({
  base: {
    borderRadius: 'medium',
    color: 'currentColor',
    display: 'flex',
    alignItems: 'center',
    gap: 'space.150',
    textDecoration: 'none',
    cursor: 'pointer',
    '&:has(+ &)': {
      mb: 'space.25',
    },
    '&[aria-current=page], &[data-active="true"]': {
      backgroundColor: 'primitives.white.100alpha30',
      _hover: { backgroundColor: 'primitives.white.100alpha30' },
    },
    _hover: { backgroundColor: 'primitives.white.100alpha15' },
  },
  variants: {
    spacing: {
      compact: { py: 'space.50' },
      default: { py: 'space.100' },
      expanded: { py: 'space.150' },
    },
  },
  defaultVariants: {
    spacing: 'default',
  },
});
